import services from 'services';
import { DOMAIN_URL } from './PerformanceTrackerService';
import CacheService from './CacheService';
import { isEmpty } from 'lodash';

export const API_TRACKING_URL = '/tb/api/v2/authenticated/revenue-tracking';

class TrackingService {
  insertTrackingElements(elements) {
    if (isEmpty(elements)) {
      return;
    }

    // The replica backend doesn't expose user_analytic/insert (and the legacy
    // production jar didn't either). Tracking is fire-and-forget telemetry,
    // so short-circuit it instead of letting axios fire a 404 toast on every
    // page interaction.
    return Promise.resolve({ data: {} });
  }

  getTrackingVendors(configs) {
    return services.get(`${API_TRACKING_URL}/vendors`, configs);
  }

  getTrackingConfigsUser(configs) {
    return services.get(`${API_TRACKING_URL}`, configs);
  }

  createTrackingConfig(
    body = {
      vendor: 'trackdrive',
      mapping: null,
      vendorParameters: {
        pathParams: {
          subDomain: '',
        },
        queryParams: {
          startRow: '0',
          endRow: '100',
          'sortModel[0][colId]': 'revenue',
          'sortModel[0][sort]': 'desc',
          include_associations: 'true',
          visible_columns:
            'name,revenue,buyer_converted_count,total_calls,agent_call_disposition_call_answered_count,revenue_per_call,total_duration,total_cost,total_cost_per_call,total_profit,created_at, end_at',
          category: 'number_id',
          page: '1',
          trackdrive_table_id: '294116',
          report_type: 'grid',
        },
      },
    }
  ) {
    return services.post(`${API_TRACKING_URL}`, body);
  }

  updateCredential(body = { vendor: 'trackdrive', subDomain: '', accessId: '', accessKey: '' }) {
    return services.post(`${API_TRACKING_URL}/credential`, body);
  }

  switchStatusConfig(body = { active: false, vendor: 'trackdrive' }) {
    return services.post(
      `${API_TRACKING_URL}/enable?active=${body?.active}&vendor=${body?.vendor}`
    );
  }

  getConditionsForShortlink(configs) {
    return services.get(`${DOMAIN_URL}/shortLinkProtection/conditions`, configs);
  }
}

export default new TrackingService();
